<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="4">
        <search-list>
          <a-form-item label="类型" v-bind="searchItemLayout">
            <a-select style="width: 100%" v-model="queryParams.type" placeholder="请选择" allowClear>
              <a-select-option :value="1">展示</a-select-option>
              <a-select-option :value="2">点击</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="位置" v-bind="searchItemLayout">
            <a-select style="width: 100%" v-model="queryParams.position" placeholder="请选择" allowClear>
              <a-select-option :value="1">首页</a-select-option>
              <a-select-option :value="2">商品详情页</a-select-option>
              <a-select-option :value="3">首页搜索页</a-select-option>
              <a-select-option :value="4">搜索发现页</a-select-option>
              <a-select-option :value="5">开屏</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="时间" v-bind="searchItemLayout">
            <a-range-picker @change="onOrderDateChange" :value="selectedOrderDate" style="width: 100%"/>
          </a-form-item>
          <a-form-item style="margin-left:2%;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <a-row class="status-list">
      <a-col :xs="6" :sm="6">
        <div class="text">展示量（次）</div>
        <div class="heading"><span>{{ showingData.totalShowNumber }}</span></div>
      </a-col>
      <a-col :xs="6" :sm="6">
        <div class="text">点击量（次）</div>
        <div class="heading">{{ showingData.totalVisitNumber }}</div>
      </a-col>
      <a-col :xs="6" :sm="6">
        <div class="text">点击率</div>
        <div class="heading"><span class="active">{{ showingData.showRate }}%</span></div>
      </a-col>
    </a-row>
    <custom-page-table
      ref="table"
      rowKey="key"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'DataStatsList',
  mixins: [searchForm],
  data() {
    return {
      selectedOrderDate: undefined,
      merchantId: this.$store.getters.userInfo.merchantId,
      adId: this.$route.query.adId,
      queryParams: {
        adId: this.$route.query.adId
      },
      showingData: {
        showRate: '',// 转换率=总访问量/总展示量 ,
        totalShowNumber: '', //总共展示量
        totalVisitNumber: '' //总访问量
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'userName'
        },
        {
          title: '手机号',
          dataIndex: 'userMobile'
        },
        {
          title: '时间',
          dataIndex: 'visitTimeStr'
        },
        {
          title: '类型',
          dataIndex: 'typeStr'
        },
        {
          title: '位置',
          dataIndex: 'positionStr'
        }
      ]
    }
  },
  mounted() {
  },
  activated() {
    this.getLogUtils().logWithTag('activated', 'activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'AdvertisingList', title: '广告列表' }
    ])
    this.adId = this.$route.query.adId
    this.getAdData()
    this.queryParams.adId = this.$route.query.adId
    this.$refs.table.refresh(true)
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getUserService().post('api/v2/ad/record/list', params)
    },
    //日期变更
    onOrderDateChange(dates, dateStrArr) {
      this.selectedOrderDate = dates
      this.queryParams.startTime = dateStrArr[0]//下单开始时间
      this.queryParams.endTime = dateStrArr[1]//下单结束时间
    },
    searchBtn() {
      this.getAdData()
      this.$refs.table.refresh(true)
    },
    //获取数据
    getAdData() {
      this.getHttpServices().getUserService().get('api/v2/ad/total?adId=' + this.adId).then(res => {
        this.getLogUtils().logWithTag('handleUpdata', res)
        this.showingData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.status-list {
  background-color: #F5F5F6;
  padding: 20px;
  font-size: 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  text-align: center;

  .text {
    margin-bottom: 10px;
  }

  .heading {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>